// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.S1ISMfldMJ0v59R6 {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 10px;
}
.FJ1i8Ypxdu0fBCKM {
  margin: 24px 0 22px 0;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}
.appinfo-input {
  width: 320px;
  height: 40px;
}
.first-row {
  flex-wrap: nowrap !important;
}
.first-row .ant-form-item-required {
  height: 40px !important;
}
.appinfo-feature {
  height: 148px;
}
.appinfo-feature textarea {
  resize: none ;
}
.appinfo-app_cate {
  width: 160px !important;
}
.appinfo-free-item .ant-form-item {
  margin-bottom: 0 !important;
  vertical-align: middle;
  margin-inline-end: 8px;
}
.appinfo-free-item .ant-radio-wrapper {
  vertical-align: middle !important;
}
.appinfo-free_trial_days {
  width: 56px;
  height: 40px;
}
.appinfo-newfeature {
  height: 148px !important;
}
.appinfo-newfeature textarea {
  resize: none ;
}
.appinfo-params {
  height: 80px !important;
}
.appinfo-params textarea {
  resize: none ;
}
.btn-cancel {
  width: 128px;
  height: 48px;
  border-radius: 8px;
  background: #FFFFFF;
  margin-right: 16px;
}
.btn-add {
  border-radius: 8px;
  opacity: 1;
  width: 128px;
  height: 48px;
  background: #0095fc;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/register/index.modules.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;EACA,oBAAA;AACF;AACA;EACE,qBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AACF;AACA;EAEI,YAAA;EACA,YAAA;AAAJ;AAHA;EAMI,4BAAA;AAAJ;AANA;EAQM,uBAAA;AACN;AATA;EAYI,aAAA;AAAJ;AAZA;EAcM,aAAA;AACN;AAfA;EAmBI,uBAAA;AADJ;AAlBA;EAuBM,2BAAA;EACA,sBAAA;EACA,sBAAA;AAFN;AAvBA;EA4BM,iCAAA;AAFN;AA1BA;EAgCI,WAAA;EACA,YAAA;AAHJ;AA9BA;EAoCI,wBAAA;AAHJ;AAjCA;EAsCM,aAAA;AAFN;AApCA;EA0CI,uBAAA;AAHJ;AAvCA;EA4CM,aAAA;AAFN;AA1CA;EAgDI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAHJ;AAjDA;EAwDI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAJJ","sourcesContent":[".registerWrapper {\n  width: 1200px;\n  margin: 0 auto;\n  padding-bottom: 10px;\n}\n.back {\n  margin: 24px 0 22px 0;\n  font-size: 14px;\n  color:#333;\n  cursor: pointer;\n}\n:global {\n  .appinfo-input {\n    width: 320px;\n    height: 40px;\n  }\n  .first-row {\n    flex-wrap: nowrap !important;\n    .ant-form-item-required {\n      height: 40px !important;\n    }\n  }\n  .appinfo-feature {\n    height: 148px;\n    textarea {\n      resize: none ;\n    }\n    \n  }\n  .appinfo-app_cate {\n    width: 160px !important;\n  }\n  .appinfo-free-item {\n    .ant-form-item {\n      margin-bottom: 0 !important;\n      vertical-align: middle;\n      margin-inline-end: 8px;\n    }\n    .ant-radio-wrapper {\n      vertical-align: middle !important;\n    }\n  }\n  .appinfo-free_trial_days {\n    width: 56px;\n    height: 40px;\n  }\n  .appinfo-newfeature {\n    height: 148px !important;\n    textarea {\n      resize: none ;\n    }\n  }\n  .appinfo-params {\n    height: 80px !important;\n    textarea {\n      resize: none ;\n    }\n  }\n  .btn-cancel {\n    width: 128px;\n    height: 48px;\n    border-radius: 8px;\n    background: #FFFFFF;\n    margin-right: 16px;\n\n  }\n  .btn-add {\n    border-radius: 8px;\n    opacity: 1;\n    width: 128px;\n    height: 48px;\n    background: #0095fc;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"registerWrapper": `S1ISMfldMJ0v59R6`,
	"back": `FJ1i8Ypxdu0fBCKM`
};
export default ___CSS_LOADER_EXPORT___;
